import { ParsedUrlQuery } from 'querystring';

import { UtmParams } from './utm-context.types';

export const extractValidQueries = (query: ParsedUrlQuery): UtmParams => {
  const parsedUtmQueries = Object.entries(query).reduce((acc, [key, value]) => {
    const utmMatch = key.match(/utm([_a-z]*)$/);

    return utmMatch
      ? {
          ...acc,
          [utmMatch[0]]: Array.isArray(value) ? value[0] : value,
        }
      : acc;
  }, {});

  const { partner_id, ref_id } = query;

  return {
    ...parsedUtmQueries,
    ...(typeof partner_id === 'string' && { partner_id }),
    ...(typeof ref_id === 'string' && { ref_id }),
  };
};

export const decodeUtmParams = (utmParams: UtmParams): UtmParams =>
  Object.entries(utmParams).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [key]: decodeURIComponent(value),
    }),
    {} as UtmParams
  );
